import React from 'react';
import { Divider, List } from '@mui/material';

import { AUTH_ITEMS } from '@/config/navigation';

import NavigationItem from './NavigationItem';

interface AuthSectionProps {
  isAuthenticated: boolean;
  onAuthAction: (action: 'login' | 'logout') => void;
  showDivider?: boolean;
}

const AuthSection = ({
  isAuthenticated,
  onAuthAction,
  showDivider = true,
}: AuthSectionProps) => {
  const authItem = isAuthenticated ? AUTH_ITEMS.LOGOUT : AUTH_ITEMS.LOGIN;
  const action = isAuthenticated ? 'logout' : 'login';

  const handleAuthClick = () => {
    onAuthAction(action);
  };

  return (
    <>
      {showDivider && <Divider sx={{ mt: 'auto', mb: 1 }} />}
      <List>
        <NavigationItem
          item={authItem}
          onClick={handleAuthClick}
          showAsLink={false}
        />
      </List>
    </>
  );
};

export default AuthSection;
